import { render, staticRenderFns } from "./EditorInsertPanel.vue?vue&type=template&id=45874ac2&scoped=true&"
import script from "./EditorInsertPanel.vue?vue&type=script&lang=js&"
export * from "./EditorInsertPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditorInsertPanel.vue?vue&type=style&index=0&id=45874ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45874ac2",
  null
  
)

export default component.exports